export default __webpack_public_path__ + "static/background-gradient-dark-purple-filled-da10c0e82312d45ce588344f8c4bac15.webp";